import React, { useState, useEffect, useRef } from 'react';
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useFetcher } from "@remix-run/react";
import axios from 'axios';
import SignInModal from './SignInModal';
import SignUpModal from './SignUpModal';

const MainAuthModal: React.FC<{ isOpen: boolean, onClose: (isOpen: boolean) => void, query: string}> = ({ isOpen, onClose, query }) => {

    const [showSignUpModal, setShowSignUpModal] = useState(false);
    const [showSignInModal, setShowSignInModal] = useState(true);


    const handleSwitchToSignUp = () => {
        setShowSignInModal(false);
        setShowSignUpModal(true);
    };

    const handleSwitchToSignIn = () => {
        setShowSignInModal(true);
        setShowSignUpModal(false);
    };
    return (
        <div className="search-modal">
            <Dialog open={isOpen} onClose={() => { }} className="relative z-50">
                <DialogBackdrop
                    className="fixed inset-0 bg-gray-500/75"
                />

                <div className="fixed inset-0 w-screen overflow-y-auto pt-20">
                    <div className="flex min-h-full items-start justify-center p-4 text-center sm:items-start sm:p-0">
                        <DialogPanel
                            className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl sm:my-8 w-[95%] sm:w-full sm:max-w-lg sm:p-6"
                        >
                            <div className="absolute right-0 top-0 pr-4 pt-4">
                                <button
                                    type="button"
                                    onClick={() => onClose(false)}
                                    className="rounded-md bg-white text-gray-900 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                                >
                                    <FontAwesomeIcon icon={faCircleXmark} className="size-6" />
                                </button>
                            </div>
                            <div className="mt-10 text-center sm:ml-4 sm:text-left">
                                <div className="relative">

                                    <div className="mt-4">
                                      {showSignInModal ? 
                                      <SignInModal 
                                        handleSwitchToSignUp={handleSwitchToSignUp}
                                        query={query}
                                      /> 
                                      : <SignUpModal
                                        handleSwitchToSignIn={handleSwitchToSignIn}
                                        query={query}
                                      />}
                                    </div>
                                </div>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default MainAuthModal;
